import { throttle } from 'lodash'
import { ref } from 'vue'

/**
 * 스크롤 발생 여부에 따른 클래스를 반환하는 훅
 * @param {string} elementId 클래스를 제어할 엘리먼트의 id
 */
export const useScrollDirection = (elementId) => {
  const elementRef = ref(null)
  const lastSrcollTopRef = ref(0)
  const lastScrollDirectionRef = ref()
  const scrollClassRef = ref('')
  const intervalTimerRef = ref(null)
  const elementTopOffsetRef = ref()

  const setScrollClass = (direction) => {
    if (direction === lastScrollDirectionRef.value) return
    scrollClassRef.value = direction === 'down' ? 'scroll-down' : 'scroll-up'
  }

  const scrollThrottleEvent = throttle(() => {
    const currentScrollTop = window.scrollY
    elementTopOffsetRef.value = elementRef.value?.getBoundingClientRect().top
    if (currentScrollTop < 0) {
      // 스크롤이 최상단(보다 위로)에 도달했을 때 (모바일에서 위로 쭉 올리면 최상단에서 좀 더 올라감)
      intervalTimerRef.value = setInterval(() => {
        const element = document.getElementById(elementId)
        if (element && window.scrollY === 0) {
          scrollClassRef.value = 'scroll-up'
          clearInterval(intervalTimerRef.value)
        }
      }, 50)
      return
    }
    const direction = currentScrollTop > lastSrcollTopRef.value ? 'down' : 'up'
    setScrollClass(direction)
    lastScrollDirectionRef.value = direction
    lastSrcollTopRef.value = currentScrollTop
  }, 100)

  const init = () => {
    elementRef.value = document.getElementById(elementId)
  }

  return {
    scrollClassRef,
    lastScrollDirectionRef,
    elementTopOffsetRef,
    lastSrcollTopRef,
    scrollThrottleEvent,
    init,
  }
}
